import {Injectable} from '@angular/core';
import {CurrentUserService} from './user.service';
import {BehaviorSubject} from 'rxjs';

export type guideKeys = 'group' | 'subgroup' | 'kind' | 'remarktype'

@Injectable({
  providedIn: 'root'
})
export class AccessService {

  private _role: Role[] = [];


  guide$: BehaviorSubject<Record<guideKeys, boolean>> = new BehaviorSubject({
    group: false,
    subgroup: false,
    kind: false,
    remarktype: false,
  } as Record<guideKeys, boolean>);
  guide = this.guide$.asObservable();

  newButton$: BehaviorSubject<Record<guideKeys | 'ratecard', boolean>> = new BehaviorSubject({
    group: false,
    subgroup: false,
    kind: false,
    remarktype: false,
    ratecard: false,
  } as Record<guideKeys | 'ratecard', boolean>);
  newButton = this.newButton$.asObservable();

  list$: BehaviorSubject<Record<UserListRightsKeys, boolean>> = new BehaviorSubject({
    registry_archive: false,
    registry_copylink: false,
    registry_create: false,
    registry_open: false,
    registry_reset: false,
  } as Record<UserListRightsKeys, boolean>);

  constructor(private userService: CurrentUserService) {
    this.role = this.userService.user$.value.roles;
    this.userService.user$.subscribe(v => {
      console.log('rights', v);
      this.newButton$.next({
        group: false,
        subgroup:  false,
        kind: false,
        remarktype:  false,
        ratecard:  false,
      });
      this.guide$.next({
        group: false,
        subgroup: false,
        kind: false,
        remarktype: false,
      });
      // this.list$.next({
      //   ...v.rights.list
      // });
    });
  }


  get role(): Role[] {
    return this._role;
  }

  set role(value: Role[]) {
    this._role = value;
  }




}
